<template>
<div class="chapter">
<div class="inner_page">
<p class="copy" style="margin-top: 2em;"><a id="pl-2-2"></a>Also available in the Words of Wisdom series:</p>
<p class="copy"><i>The Architect Says</i></p>
<p class="copy">Laura S. Dushkes</p>
<p class="copy">978-1-61689-093-3</p>
<p class="copyt">Published by</p>
<p class="copy">Princeton Architectural Press</p>
<p class="copy">37 East 7th Street, New York, New York 10003</p>
<p class="copy">Visit our website at <a href="http://www.papress.com" target="_blank">www.papress.com</a>.</p>
<p class="copyt">© 2013 Princeton Architectural Press</p>
<p class="copy">All rights reserved</p>
<p class="copy">Printed and bound in China</p>
<p class="copy">16 15 14 13 4 3 2 1 First edition</p>
<p class="copyt">No part of this book may be used or reproduced in any manner without</p>
<p class="copy">written permission from the publisher, except in the context of reviews.</p>
<p class="copyt">Every reasonable attempt has been made to identify owners of copyright.</p>
<p class="copy">Errors or omissions will be corrected in subsequent editions.</p>
<p class="copyt">Editor: Megan Carey</p>
<p class="copy">Designer: Elana Schlenker</p>
<p class="copy">Series designer: Paul Wagner</p>
<p class="copyt">Special thanks to: Nicola Bednarek Brower, Janet Behning, Fannie Bushin, Carina Cha,</p>
<p class="copy">Andrea Chlad, Benjamin English, Russell Fernandez, Will Foster, Jan Haux, Diane Levinson,</p>
<p class="copy">Jennifer Lippert, Jacob Moore, Katharine Myers, Margaret Rogalski, Dan Simon,</p>
<p class="copy">Sara Stemen, Andrew Stepanian, and Joseph Weston of Princeton Architectural Press</p>
<p class="copy">—Kevin C. Lippert, publisher</p>
<p class="copyt">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Bader, Sara, editor of compilation.</p>
<p class="copy">The designer says : quotes, quips, and words of wisdom / compiled and edited by Sara Bader. — First edition.</p>
<p class="copy">   pages cm. — (Words of wisdom)</p>
<p class="copy">ISBN 978-1-61689-134-3 (hardcover : alk. paper)</p>
<p class="copy">1. Design—Quotations. 2. Designers—Quotations. I. Title.</p>
<p class="copy">PN6084.D46B33 2013</p>
<p class="copy">745.4—dc23</p>
<p class="copy1">2012043667</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyrighttitle.vue?48c4d528